import React, {useContext, useEffect, useState} from 'react';
import LastTradesPriceGraph from './LastTradesPriceGraph';
import MonthlyPriceGraph from './MonthlyItemPriceGraph';
import {getTradeDataRequest, postBuyGraph} from 'util/api';
import AddMoneyPopupWrapper from 'components/donate/AddMoneyPopupWrapper';
import {UserContext} from 'components/user/UserContext';
import {usePopup} from 'popup/PopupContext';

const graphPrice = 100;

const TradeGraphs = ({item}) => {
    const [tradeData, setTradeData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [hasUserGraph, setHasUserGraph] = useState(true);
    const {user} = useContext(UserContext);
    const {openPopup} = usePopup();

    useEffect(() => {
        const fetchTradeData = async () => {
            try {
                const data = await getTradeDataRequest(item);
                setLoading(false);
                setTradeData(data);
            } catch (error) {
                if (error.status === 405) {
                    setHasUserGraph(false);
                }
                console.error('Error fetching trade data:', error);
            }
        };

        fetchTradeData();
    }, [item]);

    const handleBuyGraph = async () => {
        if (user.balance < graphPrice) {
            openPopup(<AddMoneyPopupWrapper initialAmount={graphPrice - user.balance}/>);
        }

        try {
            setLoading(true);
            await postBuyGraph(user.balance);
            setHasUserGraph(true);
            const data = await getTradeDataRequest(item);
            setTradeData(data);
            setLoading(false);
        } catch (error) {
            console.error('Error purchasing graph:', error);
        }
    };

    if (!hasUserGraph) {
        return (
            <div className="graph-image-container">
                <img
                    src="/images/blurred-graph.png"
                    alt="graph example"
                    width="100%"
                    onLoad={() => document.querySelector('.graph-hovering-label-underline').style.display = 'block'}
                />
                <div
                    className="graph-hovering-label graph-hovering-label-underline"
                    onClick={handleBuyGraph}
                    style={{display: 'none'}}
                >
                    $1 Unlock all graphs
                </div>
            </div>
        );
    }

    return (
        <div>
            {hasUserGraph && !loading ? (
                <div>
                    <h2>Last ten trades price graph</h2>
                    <div className="graphs-container">
                        {!loading && tradeData && tradeData.lastTenTrades.length === 0 && (
                            <div className="graph-hovering-label">
                                Item was not traded yet
                            </div>
                        )}
                        {tradeData && (
                            <LastTradesPriceGraph tradeData={tradeData}/>
                        )}
                    </div>
                    <h2>Trades per month graph</h2>
                    <div className="graphs-container">
                        {!loading && tradeData && tradeData.lastTenTrades.length === 0 && (
                            <div className="graph-hovering-label">
                                Item was not traded yet
                            </div>
                        )}
                        {tradeData && (
                            <MonthlyPriceGraph tradeData={tradeData}/>
                        )}
                    </div>
                </div>
            ) : (
                !hasUserGraph && (
                    <div className="graph-image-container">
                        <img src="/images/blurred-graph.png" alt="graph example" width={'100%'}/>
                        <div
                            className="graph-hovering-label graph-hovering-label-underline"
                            onClick={handleBuyGraph}
                        >
                            $1 Unlock all graphs
                        </div>
                    </div>
                )
            )}
        </div>
    );
};

export default TradeGraphs;